import styled from "styled-components";
import colors from "../../../../../../../styles/colorPalette";

export const Wrapper = styled.div`
  align-items: center;
  justify-content: center;
  padding-top: 50px;
  @media (max-width: 1400px) {
    margin-top: -10px;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  padding-bottom: 5px;
`;

export const Title = styled.div`
  font-family: "OpenSansRegular";
  font-style: normal;
  color: ${colors.orange1};
  font-weight: 400;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: 0.18px;
  @media (max-width: 1400px) {
    font-size: 18px;
    line-height: 22px;
  }
`;

export const CheckBoxText = styled.div`
  font-family: "OpenSansRegular";
  font-style: normal;
  color: black;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.18px;
  margin-right: auto;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  @media (max-width: 1400px) {
    font-size: 12px;
    line-height: 16px;
    margin-top: 1px;
    margin-left: 5px;
  }
`;

export const CheckContainer = styled.div`
  display: flex;
  margin-top: 17px;
`;
